import React from "react";
import "../Styles/Space.css";

const Space = () => {
  return (
    <>
      <section className="sectionSpace"></section>
    </>
  );
};

export default Space;
